<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-close-modal-button></app-close-modal-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content">
  <div class="gap-7.5 container flex flex-col items-center justify-center">
    <h1 class="raleway">Añade folios en blanco</h1>
    <div class="flex flex-row gap-10">
      <div class="flex flex-col gap-4">
        <span>Folios al principio del documento</span>
        <div class="counterContainer flex flex-row items-center justify-center gap-2">
          <input type="number" class="sheetNumber" [(ngModel)]="sheetsBefore" (input)="limit($event, 1)" />
          <ion-button color="medium-dark" fill="outline" (click)="changeSheetQty(1, -1)">
            <ion-icon icon="/assets/icon/minus-symbol.svg"></ion-icon>
          </ion-button>
          <ion-icon icon="/assets/icon/sheet.svg"></ion-icon>
          <ion-button color="medium-dark" fill="outline" (click)="changeSheetQty(1, 1)">
            <ion-icon icon="/assets/icon/plus-symbol.svg"></ion-icon>
          </ion-button>
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <span>Folios al final del documento</span>
        <div class="counterContainer flex flex-row items-center justify-center gap-2">
          <input type="number" class="sheetNumber" [(ngModel)]="sheetsAfter" (input)="limit($event, 2)" />
          <ion-button color="medium-dark" fill="outline" (click)="changeSheetQty(2, -1)">
            <ion-icon icon="/assets/icon/minus-symbol.svg"></ion-icon>
          </ion-button>
          <ion-icon icon="/assets/icon/sheet.svg"></ion-icon>
          <ion-button color="medium-dark" fill="outline" (click)="changeSheetQty(2, 1)">
            <ion-icon icon="/assets/icon/plus-symbol.svg"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <span>El formato y el gramaje de los folios corresponderán a la configuración del grupo.</span>
    </div>
    <div class="flex h-full w-full flex-row gap-2">
      <ion-button color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
      <ion-button class="flex-1" (click)="submit()">Guardar y continuar</ion-button>
    </div>
  </div>
</div>
